import { LOADER } from "resources/actionTypes";

const intialSetttings = {
  showLoader: false,
};

export const commonReducer = (state, action) => {
  if (typeof state === "undefined") {
    return intialSetttings;
  }
  switch (action.type) {
    case LOADER.LOADER_TRIGGER:
      return{
        ...state,
        showLoader:action.payload,
      };
      default:
        return state;
  }
};
